export var Breakpoint = {
  Xs: 'xs',
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg',
  Xl: 'xl',
  Xxl: 'xxl',
  Xxxl: 'xxxl'
};
export var BreakpointClass = {
  Xs: '.sfx-breakpoint-xs',
  Sm: '.sfx-breakpoint-sm',
  Md: '.sfx-breakpoint-md',
  Lg: '.sfx-breakpoint-lg',
  Xl: '.sfx-breakpoint-xl',
  Xxl: '.sfx-breakpoint-xxl',
  Xxxl: '.sfx-breakpoint-xxxl'
};